import styled from "styled-components";
import {StyleDiv} from "components/Common/StyleDiv";

export const LogoWithBackgroundContainer = styled(StyleDiv)`
  width: 750px;
  @media (max-width: 1200px) {
    display: none;
  }
`;
